import { Button, Divider, Flex, Typography } from 'antd';
import _ from 'lodash';
import TransactionIcon from '../components/TransactionIcon';
import {
  Transaction,
  TransactionStatus,
  TransactionType,
} from 'widgets/transactions/model/types';
import classes from './Transactions.module.scss';
import { useIntl } from 'react-intl';
import { SwapOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router';
import {
  formatTransactionAmount,
  getDisplayAmount,
  TransactionAmountPresentation,
} from '../lib/transactionAmountPresentation';

export default function TransactionListItem({
  transaction,
  onClick,
  amountPresentation = 'default',
}: {
  transaction: Transaction;
  onClick: (transaction: Transaction) => unknown;
  amountPresentation?: TransactionAmountPresentation;
}) {
  const { formatMessage: t } = useIntl();
  const navigate = useNavigate();

  const isPayAgainAvailable = (transaction: Transaction) => {
    return (
      (transaction.type === TransactionType.WithdrawSepa ||
        transaction.type === TransactionType.SendDebit) &&
      (transaction.status === TransactionStatus.Pending ||
        transaction.status === TransactionStatus.Approved) &&
      transaction.iban
    );
  };

  const payAgain = (item: Transaction) => {
    navigate('/pro/send/sepa', { state: { currentTemplate: item } });
  };
  const normalizedAmount =
    amountPresentation === 'default' &&
    transaction.type === TransactionType.Authorization &&
    transaction.amount > 0
      ? -transaction.amount
      : transaction.amount;

  return (
    <Flex
      key={transaction.id}
      onClick={() => onClick(transaction)}
      vertical
      className={classes['transaction']}>
      <Flex justify="space-between" align="center" style={{ padding: '8px' }}>
        <Flex gap={12} align="center">
          <div className={classes['icon-wrap']}>
            <TransactionIcon
              size={40}
              type={transaction.type}
              status={transaction.status}
            />
          </div>
          <Flex vertical gap={2}>
            <Typography.Text className={classes['transaction__recipient']}>
              {_.startCase(transaction.description || transaction.details)}
            </Typography.Text>
            <Typography.Text className={classes['transaction__description']}>
              {transaction.created?.slice(10)} {transaction.status === TransactionStatus.Declined && ` · declined`}
            </Typography.Text>
            {isPayAgainAvailable(transaction) && (
              <Button
                icon={<SwapOutlined style={{ fontSize: 14 }} />}
                size="small"
                type="link"
                className={classes['pay-again']}
                onClick={(event) => {
                  event.stopPropagation();
                  payAgain(transaction);
                }}>
                {t({ id: 'mobile.payments.button.payAgain' })}
              </Button>
            )}
          </Flex>
        </Flex>
        <Typography.Text
          className={classes['no-break']}
          strong
          type={
            transaction.status === TransactionStatus.Declined
              ? 'danger'
              : transaction.status === TransactionStatus.Pending
                ? 'secondary'
                : getDisplayAmount(normalizedAmount, amountPresentation) < 0
                  ? 'danger'
                  : 'success'
          }>
          {formatTransactionAmount(normalizedAmount, amountPresentation)}
        </Typography.Text>
      </Flex>
      <Divider style={{ margin: 0 }} />
    </Flex>
  );
}
